/**
 * en-GB messages added by Phase 3 task W16 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w16EnGB = {
    'p3w.upload.choose': 'Choose a file',
    'p3w.upload.tooBig': '{name} is {size} MB. The limit is {max} MB.',
    'p3w.upload.badType': '{name} is not an allowed type of file.',
    'p3w.upload.progress': 'Uploading {name}',
    'p3w.upload.failed': 'The upload failed. Check your connection and try again.',
    'p3w.upload.cancelled': 'The upload was cancelled.',
    'p3w.upload.done': '{name} uploaded.',
    'p3w.video.complete': 'You have watched enough of the video.',
    'p3w.video.mustWatch': 'Please watch the whole video. You cannot skip ahead.',
    'p3w.video.remaining': 'Keep watching: {seconds} more seconds needed.',
    'p3w.quiz.editor': 'Quiz questions',
    'p3w.quiz.none': 'No questions yet. A quiz is optional.',
    'p3w.quiz.addQuestion': 'Add a question',
    'p3w.quiz.preview': 'Preview the quiz',
    'p3w.quiz.hidePreview': 'Hide the preview',
    'p3w.quiz.previewNote': 'Preview: nothing is saved',
    'p3w.quiz.questionN': 'Question {n}',
    'p3w.quiz.questionText': 'Question',
    'p3w.quiz.kind': 'Answer type',
    'p3w.quiz.kind.single': 'One correct answer',
    'p3w.quiz.kind.multiple': 'More than one correct answer',
    'p3w.quiz.options': 'Answers',
    'p3w.quiz.optionsHint': 'Mark the correct answer or answers. Between 2 and 6 answers.',
    'p3w.quiz.optionN': 'Answer {n}',
    'p3w.quiz.markCorrect': 'Answer {n} of question {q} is correct',
    'p3w.quiz.addOption': 'Add an answer',
    'p3w.quiz.removeOption': 'Remove answer {n} of question {q}',
    'p3w.quiz.explanation': 'Explanation (optional)',
    'p3w.quiz.explanationHint': 'Shown after the quiz is marked.',
    'p3w.quiz.moveUp': 'Move question {n} up',
    'p3w.quiz.moveDown': 'Move question {n} down',
    'p3w.quiz.removeQuestion': 'Remove question {n}',
    'p3w.quiz.removeQuestion.short': 'Remove',
    'p3w.quiz.problem.text': 'Question {n} needs some text.',
    'p3w.quiz.problem.option': 'Every answer of question {n} needs some text.',
    'p3w.quiz.problem.correct': 'Question {n} needs at least one correct answer.',
    'p3w.quiz.problem.single': 'Question {n} allows only one correct answer.',
    'p3w.quiz.chooseOne': 'Choose one answer.',
    'p3w.quiz.chooseAll': 'Choose all that apply.',
    'p3w.quiz.answerAll': 'Answer every question to continue.',
    'p3w.quiz.submit': 'Submit answers',
    'p3w.quiz.passed': 'Passed: {correct} of {total} right ({percent}%). The pass mark is {mark}%.',
    'p3w.quiz.failed': 'Not passed: {correct} of {total} right ({percent}%). The pass mark is {mark}%.',
    'p3w.signature.blank': '{label}: empty signature pad',
    'p3w.signature.signed': '{label}: signature drawn',
    'p3w.signature.hint': 'Draw with a finger, pen or mouse.',
    'p3w.signature.undo': 'Undo last stroke',
    'p3w.signature.clear': 'Clear',
    'p3w.roll.title': 'Roll call',
    'p3w.roll.tabs': 'Roll call views',
    'p3w.roll.tab.all': 'Everyone',
    'p3w.roll.tab.unaccounted': 'Unaccounted',
    'p3w.roll.tab.missing': 'Missing',
    'p3w.roll.summary': '{safe} of {total} safe. {missing} missing, {offSite} off site.',
    'p3w.roll.live': 'Live',
    'p3w.roll.offline': 'Not live',
    'p3w.roll.search': 'Search by name, group or host',
    'p3w.roll.empty': 'Nobody to show here.',
    'p3w.roll.visitor': 'Visitor',
    'p3w.roll.permits': '{count} open permit(s)',
    'p3w.roll.check': 'Check: marks disagree',
    'p3w.roll.host': 'Host: {name}',
    'p3w.roll.status.safe': 'Safe',
    'p3w.roll.status.missing': 'Missing',
    'p3w.roll.status.offSite': 'Off site',
    'p3w.roll.status.unaccounted': 'Unaccounted',
    'p3w.roll.mark.safe': 'Safe',
    'p3w.roll.mark.missing': 'Missing',
    'p3w.roll.mark.off_site': 'Off site',
    'p3w.roll.actionsFor': 'Mark {name}',
    'p3w.roll.choosePoint': 'Muster point for {name}',
    'p3w.roll.noPoint': 'No muster point',
    'p3w.capacity.of': '{current} of {capacity}',
    'p3w.capacity.noLimit': '{current} (no limit set)',
    'p3w.capacity.state.ok': 'Space available',
    'p3w.capacity.state.near': 'Nearly full',
    'p3w.capacity.state.full': 'Full',
    'p3w.capacity.state.over': 'Over capacity',
    'p3w.chart.noData': 'No data to show yet.',
    'p3w.chart.legend': 'Chart key',
    'p3w.chart.x': 'Time',
    'p3w.scatter.metres': '{m} m',
    'p3w.scatter.north': 'N',
    'p3w.scatter.site': 'Site',
    'p3w.scatter.item': '{name}: {east} m east, {north} m north of the site',
};
//# sourceMappingURL=w16.js.map